export enum APPOINTMENTS_PERMISSIONS {
    "appointments:upcoming:list",
    "appointments:past:list:create",
    "appointment:telehealth",
    "appointment:confirm",
    "appointment:decline",
    "appointment:messages:send",
    "appointment:messages:reply"
}
